"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const misc_1 = require("./misc");
const browser_1 = require("./browser");
function setLocal(key, data) {
    const raw = misc_1.safeJsonStringify(data);
    const local = browser_1.getLocalStorageUnsafe();
    if (local) {
        local.setItem(key, raw);
    }
}
exports.setLocal = setLocal;
function getLocal(key) {
    let data = null;
    let raw = null;
    const local = browser_1.getLocalStorageUnsafe();
    if (local) {
        raw = local.getItem(key);
    }
    data = misc_1.safeJsonParse(raw);
    return data;
}
exports.getLocal = getLocal;
function removeLocal(key) {
    const local = browser_1.getLocalStorageUnsafe();
    if (local) {
        local.removeItem(key);
    }
}
exports.removeLocal = removeLocal;
//# sourceMappingURL=local.js.map